/* eslint-disable no-useless-escape */
import Vue from 'vue';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import {
  // eslint-disable-next-line camelcase
  required, email, alpha_spaces, alpha, ext, alpha_num, min_value, max_value, numeric, length, required_if, alpha_dash, size, min
} from 'vee-validate/dist/rules';
import { IdNumberValidatorBR, IdNumberValidatorCL, IdNumberValidatorPE } from 'creditu-types/validators/id-number';
import i18n from '../i18n';

extend('required', {
  ...required,
  message: (i18n.locale === 'br') ? 'Este campo é obrigatório.' : 'Este campo es obligatorio.'
});

extend('min', {
  ...min,
  message: 'min'
});

extend('size', {
  ...size,
  message: 'size'
});

extend('ext', {
  ...ext,
  message: 'ext'
});

extend('cmf_id', {
  validate(value) {
    return /^(\d{12})(A033)\b$/.test(value);
  },
  message: 'cmf_idError'
});
extend('cnpj_id', {
  validate(value) {
    return /^\d{8}\/\d{4}-\d{2}$/.test(value);
  },
  message: 'Use o formato válido CNPJ 12345678/0001-01'
});
extend('phoneBr', {
  validate(value) {
    return /^\+55\d{10,11}$/.test(value);
  },
  message: 'Use o formato +552288888888 ou +5522988888888'
});

extend('min_value', {
  // eslint-disable-next-line camelcase
  ...min_value,
  message: (fieldName, placeholders) => `Debe ser mayor o igual a ${placeholders.min}`
});

extend('max_value', {
  // eslint-disable-next-line camelcase
  ...max_value,
  message: (fieldName, placeholders) => `Debe ser menor o igual a ${placeholders.max}`
});

extend('required_if', {
  // eslint-disable-next-line camelcase
  ...required_if,
  message: 'required_if'
});

extend('idNumberBr', val => {
  const idNumberValidatorBR = new IdNumberValidatorBR();
  return idNumberValidatorBR.validate(val);
});
extend('idNumberCl', val => {
  const idNumberValidatorCL = new IdNumberValidatorCL();
  return idNumberValidatorCL.validate(val);
});
extend('idNumberPe', val => {
  const idNumberValidatorPE = new IdNumberValidatorPE();
  return idNumberValidatorPE.validate(val);
});

extend('bankValidation', {
  validate(value) {
    return value !== '';
  },
  message: 'bankValidationError'
});

extend('smsValidation', {
  validate(value) {
    return value !== '';
  },
  message: 'smsValidationError'
});

extend('email', {
  ...email,
  message: (i18n.locale === 'br') ? 'O e-mail deve incluir @' : 'El email debe incluir @ '
});

extend('emailbr', {
  ...email,
  message: 'Este e-mail é inválido'
});

extend('phonecl', {
  validate: value => /^[ \s/0-9]{11}$/.test(value),
  message: 'Este teléfono no es válido'
});

extend('phoneGlobalcl', {
  validate: value => /^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/gm.test(value),
  message: 'Este teléfono no es válido'
});

extend('phoneGlobalpe', {
  validate: value => /^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/gm.test(value),
  message: 'Este teléfono no es válido'
});

extend('phoneGlobalbr', {
  validate: value => /^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/gm.test(value),
  message: 'Este telefone não é válido'
});

extend('len', {
  ...length,
  message: 'errorMaxLenght'
});

extend('alpha_spaces', {
  // eslint-disable-next-line camelcase
  ...alpha_spaces,
  message: 'errorAlpha_spaces'
});

extend('alpha_dash', { ...alpha_dash, message: 'alpha_dash' }); // eslint-disable-line camelcase

extend('alpha', {
  ...alpha,
  message: 'errorAlpha'
});

extend('alpha_num', {
  // eslint-disable-next-line camelcase
  ...alpha_num,
  message: 'errorAlpha_num'
});

extend('numeric', {
  ...numeric,
  message: 'Debe contener solo caracteres numéricos'
});

extend('cardCodeValidation', {
  params: ['coord0', 'coord1', 'coord2'],
  validate(value, { coord0, coord1, coord2 }) {
    const test0 = /^([0-9]{2})$/.test(coord0);
    const test1 = /^([0-9]{2})$/.test(coord1);
    const test2 = /^([0-9]{2})$/.test(coord2);
    return (test0 && test1 && test2);
  },
  message: 'cardCodeValidationError'
});

extend('passwordValidation', {
  validate(value) {
    return value.length > 0;
  },
  message: 'passwordValidationError'
});

extend('password', {
  params: ['target'],
  validate(value, { target }) {
    return value === target;
  },
  message: 'Password confirmation does not match'
});

// Register it globally
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
